export const WIDGET_MEDIA_EMPTY_STATE = 'WIDGET_MEDIA_EMPTY_STATE';
export const WIDGET_MEDIA_LOAD_MORE_LOADING_STATE =
  'WIDGET_MEDIA_LOAD_MORE_LOADING_STATE';
export const WIDGET_MEDIA_LOAD_MORE_ERROR_STATE =
  'WIDGET_MEDIA_LOAD_MORE_ERROR_STATE';
